<template>
  <div class="QzSplit">{{ text }}</div>
</template>

<script>
export default {
  name: "QzSplit",
  props: {
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.QzSplit {
  padding: 7px 15px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  background-color: #F2F2F4;
}
</style>



// WEBPACK FOOTER //
// src/components/common/QzSplit/index.vue